import script from "./School.vue?vue&type=script&setup=true&lang=js"
export * from "./School.vue?vue&type=script&setup=true&lang=js"

import "./School.vue?vue&type=style&index=0&id=2c58744e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c58744e"]])

export default __exports__